import { useFormikContext } from "formik";
import React, { FC, useState } from 'react';
import { DEF_PG_SIZE_WIZARD } from '../../../../constants/maximum-page-size';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { TableContextProvider } from '../../../../contexts/table/TableContextProvider';
import { TableColumn } from '../../../../models/table/TableColumn';
import DashboardTable from '../../dashboard-table';
import { WizardStepLayout } from '../../../wizard/wizard-summary-layout';
import { getCategoryNameWithPagination } from "../../../../services/categoryService";

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
}

const TypeSelectionStep: FC<Props> = ({ onBack, onNext, setSideBarStepDescription, }) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();
    const { setFieldValue, values, resetForm } = useFormikContext<any>();

    const TempColumns: TableColumn[] = [
        {
            heading: "Type",
            accessor: "label",
            isNumeric: false,
            id: 0,
            sortByName: "trnName",
            sortDirection: "asc",
            active: true,
            translationKey: translate.byKey(TranslationKeys.type),
            isDefault: true,
        }
    ];

    const onLocalNext = (event: any) => {
        if (taskSelected) {
            onNext({ ...event });
            setSideBarStepDescription(values.categoryType)
        }
    };

    const itemSelected = (selectedItem: any) => {
        resetForm();
        if (selectedItem) {
            setTaskSelected(true);
            setFieldValue("categoryType", selectedItem.label);
            setFieldValue("categoryTypeId", selectedItem.value);
            setFieldValue("categoryTypeSysname", selectedItem.elementSysname);
            setSideBarStepDescription(selectedItem.label);
            onNext({});
        }
    };
    
    return <WizardStepLayout onBack={onBack} onNext={onLocalNext} nextDisabled={!taskSelected}>
        <div className="flex flex-col h-full">
            <div className="mb-3 text-portal-blue-primary-shade2 text-xl font-semibold">{translate.byKey(TranslationKeys.selectCategoryType)}</div>
            <div className="flex-1 min-h-0">
                <TableContextProvider
                    useTable
                    dataMethod={getCategoryNameWithPagination}
                    tableDescriptor={TempColumns}
                    disableSearch={true}
                    maxPageSize={DEF_PG_SIZE_WIZARD}>
                    <DashboardTable onRowClicked={itemSelected}/>
                </TableContextProvider>
            </div>
        </div>
    </WizardStepLayout>
};

export default TypeSelectionStep;